{
    "status": {
        "success": "Completado",
        "refunded": "Devuelto",
        "resended": "Enviado",
        "renovated": "Renovado",
        "error": "Error",
        "pending": "Pendiente",
        "pending_short": "Pend."
    },
    "type": {
        "subscriptionBuy": "Compra de abono",
        "subscriptionGift": "Regalo de abono",
        "subscriptionRenovation": "Renovación de abono",
        "subscriptionReturn": "Devolución de abono",
        "subscriptionResend": "Reenvío de abono",
        "subscriptionGiftRefund": "Devolución de regalo de abono",
        "subscriptionRenewalRefund": "Devolución de renovación de abono",
        "subscriptionGiftResend": "Reenvío de regalo de abono",
        "subscriptionRenewalResend": "Reenvío de renovación de abono",
        "subscriptionBuyPartialRefund": "Devolución parcial de abono",
        "subscriptionGiftPartialRefund": "Devolución parcial de regalo de abono",
        "ticketBuy": "Compra de entrada",
        "ticketReturn": "Devolución de entrada",
        "ticketResend": "Reenvío de entrada",
        "ticketPartialRefund": "Devolución parcial de entrada"
    },
    "articleType": {
        "REFUND_SUBSCRIPTION_ALL": "Devolución de todos los abonos",
        "REFUND_TICKET_ALL": "Devolución de todas las entradas",
        "REFUND_SUBSCRIPTION": "Devolución de abono",
        "REFUND_TICKET_SUBSCRIBER": "Devolución de entrada de abonado",
        "REFUND_TICKET_ACCOMPANYING": "Devolución de entrada de acompañante",
        "REFUND_TICKET_PRODUCT": "Devolución de productos",
        "RESEND_SUBSCRIPTION": "Reenvío de abono",
        "RESEND_TICKET": "Reenvío de entrada",
        "RESEND_RENEWAL": "Reenvío de renovación de abono",
        "REFUND_RENEWAL": "Devolución de renovación de abono",
        "REFUND_TICKET_PARTIAL": "Devolución parcial de entrada"
    }
}
